import React from 'react';

export const SearchInput = ({ onSearch, searchText }) => {
  return (
    <input
      type="textfield"
      placeholder={`Search ${searchText}`}
      onChange={evt => {
        onSearch(evt.currentTarget.value);
      }}
      style={{
        height: 30,
        borderRadius: 15,
        background: '#F7F7FC',
        border: '1px solid #D9DBE9',
        alignItems: 'center',
        padding: '12px 24px 12px 16px',
        width: 400
      }}
    />
  );
};
